<div class="ot-field-label-wrapper" *ngIf="label">
  <file360-field-inline-label [elementId]="elementId" [label]="label" [hoverTip]="hoverTip"
    [showRequiredIndication]="showRequiredIndication" [readOnly]="readOnly"></file360-field-inline-label>
</div>